import { z } from 'zod';

const tokenSchema = z.object({
  token: z.string(),
  expires: z.string().datetime(),
});

const securitySchema = z.object({
  sms: z.string(),
});

export const AuthResponseSchema = z.object({
  user: z
    .object({
      firstName: z.string(),
      phone: z.string().optional(),
      lastName: z.string(),
      email: z.string().email(),
      role: z.enum(['user', 'admin']),
      isEmailVerified: z.boolean(),
      _id: z.string(),
    })
    .optional(),
  tokens: z
    .object({
      access: tokenSchema,
      refresh: tokenSchema,
    })
    .optional(),
  security: securitySchema.optional(),
});

export type AuthResponse = z.infer<typeof AuthResponseSchema>;
// aliases for convenience
export type LoginResponse = AuthResponse;

export const LoginFormSchema = z.object({
  email: z.string().min(1, 'Email address is required'),
  password: z.string().min(1, 'Password is required'),
});

export const EnrollFormSchema = LoginFormSchema.extend({
  phone: z.string().min(1, 'Phone number is required'),
});

export const VerifyCodeFormSchema = LoginFormSchema.extend({
  code: z.string().min(1, 'Please enter a verificaiton code'),
});

export type LoginRequest = z.infer<typeof LoginFormSchema>;

export const RegisterResponseSchema = z.object({
  message: z.string(),
});

export type RegisterResponse = z.infer<typeof RegisterResponseSchema>;

export const RegisterRequestFormSchema = z
  .object({
    email: z
      .string()
      .min(1, { message: 'Email is required' })
      .email('Please enter a valid email address'),
    firstName: z.string().min(1, { message: 'Name is required' }),
    lastName: z.string().min(1, { message: 'Name is required' }),
    password: z
      .string()
      .min(1, { message: 'Password is required' })
      .min(8, { message: 'Password must be at least 8 characters long}' }),
    confirmPassword: z.string().min(1, { message: 'Please confirm password' }),
  })
  .refine(({ password, confirmPassword }) => password === confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });

export interface RegisterRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  recaptchaToken: string;
}

// Reset Password
export const ResetPasswordResponseSchema = z.object({
  message: z.string(),
});
export type ResetPasswordResponse = z.infer<typeof ResetPasswordResponseSchema>;
export const ResetPasswordFormSchema = z.object({
  email: z.string().min(1, 'Email address is required'),
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordFormSchema>;
